import React from 'react';
import { motion } from 'framer-motion';

// Variantes de transition selon le type de navigation
const variants = {
  // Entrée depuis la droite (navigation vers l'avant)
  slideIn: {
    initial:  { opacity: 0, x: 40 },
    animate:  { opacity: 1, x: 0 },
    exit:     { opacity: 0, x: -40 },
  },
  // Fondu simple
  fade: {
    initial:  { opacity: 0 },
    animate:  { opacity: 1 },
    exit:     { opacity: 0 },
  },
  // Zoom entrant (pour pages modales/importantes)
  zoomIn: {
    initial:  { opacity: 0, scale: 0.95 },
    animate:  { opacity: 1, scale: 1 },
    exit:     { opacity: 0, scale: 1.02 },
  },
  // Remontée depuis le bas (pour pages de jeu)
  slideUp: {
    initial:  { opacity: 0, y: 30 },
    animate:  { opacity: 1, y: 0 },
    exit:     { opacity: 0, y: -20 },
  },
  // PREMIUM: Slide depuis la gauche avec bounce
  slideInLeft: {
    initial:  { opacity: 0, x: -50 },
    animate:  { opacity: 1, x: 0 },
    exit:     { opacity: 0, x: 50 },
  },
  // PREMIUM: Zoom avec rotation
  zoomRotate: {
    initial:  { opacity: 0, scale: 0.8, rotate: -5 },
    animate:  { opacity: 1, scale: 1, rotate: 0 },
    exit:     { opacity: 0, scale: 0.8, rotate: 5 },
  },
  // PREMIUM: Slide depuis le bas avec glow
  slideUpGlow: {
    initial:  { opacity: 0, y: 50 },
    animate:  { opacity: 1, y: 0 },
    exit:     { opacity: 0, y: -30 },
  },
  // PREMIUM: Flip card
  flipIn: {
    initial:  { opacity: 0, rotateX: -90 },
    animate:  { opacity: 1, rotateX: 0 },
    exit:     { opacity: 0, rotateX: 90 },
  },
};

/**
 * Wrapper de transition de page
 * variant: 'slideIn' | 'fade' | 'zoomIn' | 'slideUp' | 'slideInLeft' | 'zoomRotate' | 'slideUpGlow' | 'flipIn'
 */
function PageTransition({ children, variant = 'slideIn', className = '' }) {
  const v = variants[variant] || variants.slideIn;

  // Configuration des transitions par variante
  const transitionConfig = {
    slideIn: { duration: 0.22, ease: [0.25, 0.46, 0.45, 0.94] },
    fade: { duration: 0.22, ease: [0.25, 0.46, 0.45, 0.94] },
    zoomIn: { type: 'spring', stiffness: 150, damping: 20, duration: 0.35 },
    slideUp: { duration: 0.25, ease: [0.25, 0.46, 0.45, 0.94] },
    slideInLeft: { type: 'spring', stiffness: 120, damping: 18, duration: 0.4 },
    zoomRotate: { type: 'spring', stiffness: 180, damping: 22 },
    slideUpGlow: { duration: 0.3, ease: [0.23, 1, 0.32, 1] },
    flipIn: { type: 'spring', stiffness: 200, damping: 25 },
  };

  const transitionForVariant = transitionConfig[variant] || transitionConfig.slideIn;

  return (
    <motion.div
      initial={v.initial}
      animate={v.animate}
      exit={v.exit}
      transition={transitionForVariant}
      className={className}
      style={{ width: '100%', willChange: 'transform, opacity' }}
    >
      {children}
    </motion.div>
  );
}

export default PageTransition;
